import { hotRecommend } from '@/mocks/movies';

export default function HotRecommend() {
  return (
    <section id="hot" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest">HOT PICKS</span>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              热门推荐：值得优先放进片单的 6 部
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              不必从零筛选。以下六部兼顾评分与观看体验，每一部都附上推荐理由，适合直接照着看。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {hotRecommend.map((pick, idx) => (
              <article
                key={pick.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 hover:border-primary-300 transition-colors"
              >
                <div className="relative w-full h-56 md:h-60 overflow-hidden">
                  <img
                    src={pick.poster}
                    alt={`《${pick.title}》推荐海报`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                    <i className="ri-star-smile-line" aria-hidden="true"></i>
                    编辑推荐 {String(idx + 1).padStart(2, '0')}
                  </span>
                  <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-foreground-950/75 text-background-50 text-xs font-medium backdrop-blur-sm">
                    {pick.douban.toFixed(1)} 分
                  </span>
                </div>

                <div className="flex flex-col flex-1 p-4 md:p-5">
                  <div className="flex items-baseline gap-2">
                    <h3 className="font-heading font-bold text-lg text-foreground-950">{pick.title}</h3>
                    <span className="text-xs text-foreground-500">{pick.year}</span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-500">{pick.region}</p>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{pick.reason}</p>
                  <a
                    href="#douban"
                    className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 cursor-pointer"
                  >
                    查看同类高分
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}